function Card({ imgSrc, number, title, lightColor, darkColor, underline }) {
  return (
    <div
      className="m-1 py-4 text-light d-flex justify-content-evenly align-items-center"
      style={{
        backgroundImage: `linear-gradient(to left, ${lightColor} , ${darkColor})`,
        borderRadius: "10px",
        height: "230px",
      }}
    >
      <div className="text-center">
        <div className="fs-5 mb-3">{title}</div>
        <div
          className={`${underline && "border-bottom"} border-3 d-inline fs-3`}
        >
          {number}
        </div>
      </div>
      <img src={`${imgSrc}`} style={{ height: "120px" }} />
    </div>
  );
}

export default Card;
